import { Box, Breadcrumbs, IconButton, Link, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { ArrowBackIos } from '@mui/icons-material';
import Dashboard from './Dashboard';
import { IReportData } from '../shared/interfaces';
import { MatrixService } from "../services/matrixservice";
import { Page } from './layout/Page';
import ReactDOM from 'react-dom';
import ReportCards from './ReportCards';
import { SpinnerContainer } from "./shared/SpinnerContainer";

const matrixService = new MatrixService();

const MAX_ITEMS_BEFORE = 2;
const MAX_ITEMS_AFTER = 8;
export type Props = {
  reportTypes: string[]
}

const Reports: React.FC<{reportTypes: string[]}> = ({ reportTypes }) => {

  const theme = useTheme();
  const mdBreakAfter = useMediaQuery(theme.breakpoints.up("md"));
  const [reportDisplay, setReportDisplay] = useState(false);
  const [currentReport, setCurrentReport] = useState<IReportData>({ReportName: "no Report", DashboardId:"none", ReportType:"bookings", ImageFile: "thumb-0"});
  const [reportDefs, setReportDefs] = useState<IReportData[]>([]);
  const [loading, setLoading] = useState(false);

  const showReport = (dash:IReportData) => {
    setCurrentReport(dash)
    setReportDisplay(true);
  }

  const closeReport = () => {
    setLoading(true);
    setReportDisplay(false);
    let container = document.querySelector('#embeddingContainer');
    if(container) {
      container.innerHTML = '';
    }
    getReportDefs(reportTypes);
  }

  const getReportDefs = async (reportTypes:string[]) => {
    const reportData = await matrixService.getReportData(reportTypes);
    setReportDefs(reportData);
    setLoading(false);
  }
  
  const renderBreadcrumbNav = ():JSX.Element => {

    return (
      <div className="tw-bg-white tw-flex tw-items-center tw-py-1" style={{minHeight: "55px", boxShadow: "0 2px 2px rgb(0,0,0,0.2)"}}>
        <div className="tw-flex tw-items-start tw-w-11/12 tw-mx-auto tw-pt-1">
          <IconButton aria-label="back" className="tw-text-gray1 tw-relative" style={{bottom: "4px", padding: "4px"}} onClick={closeReport}>
            <ArrowBackIos />
          </IconButton>
            <Breadcrumbs aria-label="breadcrumb" className="tw-text-gray1"
              sx={{color: "#343535"}} 
              maxItems={ mdBreakAfter ? MAX_ITEMS_AFTER : MAX_ITEMS_BEFORE }>
                <Link component="a" onClick={closeReport}>Home</Link>
                <Link component="a">{currentReport.ReportName}</Link>
            </Breadcrumbs>
          </div>
      </div>
    );
  }

 useEffect(() => {  

    ReactDOM.render(<ReportCards reportDefs={reportDefs} showReport={showReport}  />,
    document.querySelector('#CardGrid'));
    
 }, [reportDefs]);
  

  if(!loading && reportDefs.length === 0) {
    setLoading(true);
    getReportDefs(reportTypes).then(()=>{
      setLoading(false);
    });
  }

  return (
    <>
      {reportDisplay &&
        <>
          {renderBreadcrumbNav()}
          <Page>
            <Dashboard dashboardId={currentReport.DashboardId} reportType={currentReport.ReportType} />
          </Page>
        </>
      }

      {(!reportDisplay && loading) &&
        <div className="tw-h-screen">
          <div className= "tw-h-4/6 tw-grid tw-w-full tw-place-content-center">
              <SpinnerContainer />
            </div>
        </div>
      }

      {!reportDisplay &&
        <Page>          
          <Box sx={{display: "flex", gap: 2, flexWrap:"wrap" }} id="CardGrid">
          </Box>
        </Page>
      }
    </>
  );
  
}

export default Reports;